import { mapGetters } from 'vuex'

export const UserInfoMixins = {
  watch: {
    $route() {
      this.refreshUserInfo()
    },
  },
  data() {
    return {
      UserInfo: {
        PhoneNumber: 'Loading...',
        BankAccount: 'Loading...',
        BankCode: 'Loading...',
        regisdate: 'Loading...',
        ItemCode: false,
        totalDeposit: 'Loading...',
        totalWithdraw: 'Loading...',
        affiliateKey: 'Loading...',
        GameInfo: {
          username: 'Loading...',
          password: 'Loading...',
          Partner: 'Loading...',
        },
        userRank: {
          userRank: 'Loading...',
          userExp: 'Loading...',
        },
        internalWallet: {
          mainWallet: 'Loading...',
          gameWallet: 'Loading...',
          affiliateWallet: 'Loading...',
          cashbackWallet: 'Loading...',
          residualWallet: 'Loading...',
          prizeWallet: 'Loading...',
          spinWallet: 'Loading...',
        },
        userName: {
          firstName: 'Loading...',
          lastName: 'Loading...',
          fullName: 'Loading...',
        },
        BonusInfo: {
          bonusId: 'Loading...',
          isBonus: 'Loading...',
          TurnoverType: 'Loading...',
          needTurnover: 'Loading...',
          nowTurnover: 'Loading...',
          maxWithdrawType: 'Loading...',
          maxWithdrawAmount: 'Loading...',
          reviceDate: 'Loading...',
          DepositAmount: 'Loading...',
        },
      },
    }
  },
  computed: {
    ...mapGetters(['getError', 'getLoading', 'getUser']),
  },
  methods: {
    async refreshUserInfo() {
      if (this.getUser) {
        this.UserInfo = await this.getUser
      }
    },
  },
  async mounted() {
    if (this.getUser) {
      this.UserInfo = await this.getUser
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/UserInfo.js